import { render } from "./SegurancaDados.vue?vue&type=template&id=2ab8e75a&scoped=true"
import script from "./SegurancaDados.vue?vue&type=script&lang=js"
export * from "./SegurancaDados.vue?vue&type=script&lang=js"

import "./SegurancaDados.vue?vue&type=style&index=0&id=2ab8e75a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab8e75a"]])

export default __exports__